import { render, staticRenderFns } from "./BarChartViewerCustom.vue?vue&type=template&id=3a7bd00e&scoped=true&"
import script from "./BarChartViewerCustom.vue?vue&type=script&lang=js&"
export * from "./BarChartViewerCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7bd00e",
  null
  
)

export default component.exports